
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, CardTitle, Form, FormGroup, Input, Button } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from 'axios';
import { toast } from "react-toastify";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Country, State, City } from "country-state-city";
import RenderRazorpay from './RenderRazorPay';
import StepIndicator from './StepIndicator';
import { profiledata } from '../../slices/thunks';
import BillingDetails from './billingDetails';
import { BillingAPI, OrderAPI } from '../../helpers/firebase_helper';

const BillingAddress = () => {
  const profileData = useSelector((state) => state.Profile.profileData);
  const [cognito_id, setCognitoId] = useState(null);
  const dispatch = useDispatch();
  const [orderTotal, setOrderTotal] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedPlan, currentPaidPlan } = location.state || {};
  const [savedBillingDetails, setSavedBillingDetails] = useState(null);
  const [newBillingDetails, setNewBillingDetails] = useState({
    organization_type: '',
    firstname: '',
    lastname: '',
    phone_number: '',
    email: '',
    country: '',
    state: "",
    city: "",
    address: "",
    zipcode: "",
    gst_number: "",
  });
  const [orderDetails, setOrderDetails] = useState(null);
  const paidPlanAmount = currentPaidPlan.amount;
  const planExpiryDate = profileData?.result?.next_charge_date;
  const paidPlanFrequency = profileData?.result?.billing_frequency;
  const paidPlanName = profileData?.result?.current_plan;
  const [orderSummary, setOrderSummary] = useState({
    cartAmount: selectedPlan?.amount || 0,
    taxAmount: 0,
    order_total: selectedPlan?.amount || 0,
    taxes: [],
  });
  const [currency, setCurrency] = useState("USD");
  const [razorpayVisible, setRazorpayVisible] = useState(false);
  const [proceedToPaymentEnabled, setProceedToPaymentEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const countries = Country.getAllCountries();
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const steps = [
    { label: "Select Plan", path: "/billing/current-plan" },
    { label: "Billing Address", path: "/billing/billing-address" },
    { label: "Payment", path: "/payment" },
  ];
  const [activeStep, setActiveStep] = useState(1);

  const handleStepClick = (stepIndex) => {
    if (stepIndex < activeStep) {

      navigate(steps[stepIndex].path);
      setActiveStep(stepIndex);
    }
  };

 

  useEffect(() => {
    const fetchUser = async () => {
      const result = profileData?.result?.cognito_id;


      setCognitoId(result);
      if (cognito_id) {
        fetchBillingDetails(cognito_id);
      }

    };

    const fetchBillingDetails = async (cognito_id) => {
      try {
        const response = await BillingAPI.fetchBillingInfo(cognito_id);
        if (response) {
          setSavedBillingDetails(response.result);
          setNewBillingDetails(response.result);
        }
      } catch (error) {
        toast.error("Failed to load billing details.");
      }
    };
    fetchUser();

    if (!selectedPlan) {
      toast.error("Please select plan to proceed.");
      navigate("/billing/plans");
    }

  }, [profileData, cognito_id, selectedPlan]);
  
  useEffect(()=> {
    if(savedBillingDetails?.country){
      const statesList = State.getStatesOfCountry(savedBillingDetails?.country);
    setStates(statesList);
    }
  },[savedBillingDetails])

  useEffect(() => {

    if (newBillingDetails.country && newBillingDetails.state) {
      calculateTax();
    }
  }, [newBillingDetails]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewBillingDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    setNewBillingDetails((prevState) => ({
      ...prevState,
      country: selectedCountry,
      state: statesList.length ? "" : selectedCountry,
    }));
    const statesList = State.getStatesOfCountry(selectedCountry);
    setStates(statesList);
  };
  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setNewBillingDetails((prevState) => ({
      ...prevState,
      state: selectedState,
      city: "",
    }));

    const citiesList = City.getCitiesOfState(newBillingDetails.country, selectedState);
    setCities(citiesList);
  };

  const handleSaveBillingDetails = async () => {
    const requiredFields = [
      "organization_type",
      "firstname",
      "lastname",
      "phone_number",
      "email",
      "country",
      "state",
      "city",
      "address",
      "zipcode",
    ];

    for (let field of requiredFields) {
      if (!newBillingDetails[field]) {
        toast.error(`Please fill in the ${field} field.`);
        return;
      }
    }

    try {
      const billingDetailsToSend = {
        ...newBillingDetails,
        billing_plan: paidPlanName, 
        next_charge_date: planExpiryDate, 
        billing_frequency: paidPlanFrequency, 
      };

      const response = await BillingAPI.updateBillingInfo(cognito_id, billingDetailsToSend);

      setSavedBillingDetails(newBillingDetails);
      toast.success(response?.message || "Billing details updated successfully.");

    } catch (error) {
      toast.error("Failed to save billing details.");
    }
  };



  const calculateTax = async () => {
    setLoading(true);

    try {
      const apiPayload = {
        country_name: newBillingDetails.country,
        state_name: newBillingDetails.state || country_name,
        cart_amount: selectedPlan.amount,
        new_plan_name: selectedPlan.type,
        paid_plan_amount: paidPlanAmount,
        plan_expiry_date: planExpiryDate,
        paid_plan_frequency: paidPlanFrequency,
        paid_plan_name: paidPlanName,

      };


      const response = await OrderAPI.orderTotal(apiPayload);

      if (response.status === 'success') {
        const result = response.result;
        setOrderTotal(result);
        
        setCurrency(result.currency);
        setOrderSummary({
          cartAmount: result.cart_amount || selectedPlan.amount,
          taxAmount: result.tax_amount || 0,
          order_total: result.order_total || selectedPlan.amount,
          taxes: result.taxes || [],
          note: result.note || null,
          remainingAmount: result.remaining_amount || 0,
          originalAmount: result.original_cart_amount || selectedPlan.amount,
        });
       
        setProceedToPaymentEnabled(true); // Enable the button once tax is calculated
      } else {
        console.error("Error calculating order total:", response.data.message);
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateOrder = async (plan, totalAmount) => {

    setLoading(true);
    try {
      const apiPayload = {


        cognito_id: cognito_id,
        cart_amount: orderTotal.cart_amount,
        state_name: orderTotal.state_name,
        tax_amount: orderTotal.tax_amount,
        order_total: orderTotal.order_total,
        currency: orderTotal.currency,
        frequency: selectedPlan.period,
        exchange_rate: orderTotal.exchange_rate || 0,
        line_items: [
          {
            plan_name: plan.type,
            plan_id: plan.id,
            plan_frequency: plan.period,
            amount: orderTotal.cart_amount,
            quantity: 1,
          },
        ],
        taxes: [{
          amount: 0,
          currency: "USD",
          name: "IGST",
          rate: 0,
          type: "gst"
        }],
      };


      if (orderTotal.tax_amount > 0) {
        apiPayload.taxes = orderTotal.taxes.map((tax) => ({
          amount: tax.amount,
          currency: tax.currency,
          name: tax.name,
          rate: tax.rate,
          type: tax.type,
        }));
      }

      const response = await OrderAPI.orderCreate(apiPayload);

      if (response.status === 'success') {
        const orderData = response;

        setOrderDetails({
          order_id: orderData?.result?.id,
          amount: orderData?.result?.amount,
          currency: orderData?.result?.currency,
          customer_id: orderData?.result?.notes?.customer_id
        });

        setRazorpayVisible(true);
        setActiveStep(2);
      }
    } catch (error) {
      console.error("Error creating order", error);
    } finally {
      setLoading(false);
    }
  };
  const handleProceedToPayment = async (plan, totalAmount) => {
    try {

      await handleSaveBillingDetails();

      await handleCreateOrder(plan, totalAmount);

      toast.success("Proceeding to payment...");
    } catch (error) {
      console.error("Error during payment process:", error);
      toast.error("Failed to proceed to payment. Please try again.");
    }
  };


  const handlePaymentSuccess = (paymentResponse) => {
    setActiveStep(3);
    dispatch(profiledata(cognito_id));
    navigate("/billing/current-plan");
  };

  const handelCancel = () => {
    setRazorpayVisible(false);
    setActiveStep(1);
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Billing and Payment" pageTitle="Billing Address and Order Summary" />
        <StepIndicator activeStep={activeStep} steps={steps} onStepClick={handleStepClick} />
        <Card>
          <Row>

            <Col lg={6}>

              <CardBody>
                <CardTitle tag="h5" className="mb-4">Billing Address</CardTitle>
                <Form>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <label for="organization_type">Organization Type</label>
                        <Input
                          type="select"
                          name="organization_type"
                          value={newBillingDetails.organization_type}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Type</option>
                          <option value="Individual">Individual</option>
                          <option value="Organization">Organization</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <label for="gst_number">GST/VAT Number</label>
                        <Input
                          type="text"
                          id="gst_number"
                          name="gst_number"
                          value={newBillingDetails.gst_number}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <label for="firstname">First Name</label>
                        <Input
                          type="text"
                          id="firstname"
                          name="firstname"
                          value={newBillingDetails.firstname}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <label for="lastname">Last Name</label>
                        <Input
                          type="text"
                          id="lastname"
                          name="lastname"
                          value={newBillingDetails.lastname}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <label for="phone_number">Phone Number</label>
                        <Input
                          type="text"
                          id="phone_number"
                          name="phone_number"
                          value={newBillingDetails.phone_number}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <label for="email">Email</label>
                        <Input
                          type="email"
                          id="email"
                          name="email"
                          value={newBillingDetails.email}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <label for="country">Country</label>
                        <Input
                          type="select"
                          id="country"
                          name="country"
                          onChange={handleCountryChange}
                          value={newBillingDetails.country || ""}
                        >
                          <option value="">Select Country</option>
                          {countries.map((country) => (
                            <option key={country.isoCode} value={country.isoCode}>
                              {country.name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <label for="state">State</label>
                        <Input
                          type="select"
                          id="state"
                          name="state"
                          onChange={handleStateChange}
                          value={newBillingDetails.state || ""}
                          disabled={!states.length}
                        >
                          <option value="">Select State</option>
                          {states.map((state) => (
                            <option key={state.isoCode} value={state.isoCode}>
                              {state.name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <label for="city">City</label>
                        <Input
                          type="select"
                          id="city"
                          name="city"
                          onChange={handleInputChange}
                          value={newBillingDetails.city || ""}
                          disabled={!cities.length}
                        >
                          <option value="">Select City</option>
                          {cities.map((city) => (
                            <option key={city.id} value={city.name}>
                              {city.name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <label for="address">Address</label>
                        <Input
                          type="text"
                          id="address"
                          name="address"
                          value={newBillingDetails.address || ""}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <label for="zipcode">ZipCode / PinCode</label>
                        <Input
                          type="text"
                          id="zipcode"
                          name="zipcode"
                          value={newBillingDetails.zipcode || ""}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </CardBody>

            </Col>


            <Col lg={1} className="d-flex justify-content-center ">
              <div
                className="d-none d-lg-block"
                style={{
                  width: '3px',
                  backgroundColor: '#dee2e6',
                  margin: '50px 15px',
                }}
              ></div>
            </Col>

            <Col lg={5} className="d-flex justify-content-center align-items-start">
              <div className="order-summary mt-5 "
                style={{
                  width: '70%',
                  maxWidth: '800px',
                  marginRight: '50px',
                }}>

                <Card className="p-4 shadow-lg bg-light rounded" style={{ width: '100%' }}>

                  <div className="text-center mb-4">
                    <h3 >Order Summary</h3>
                  </div>

                  <div className="mb-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Plan</h5>
                      <p className="text-muted">{selectedPlan?.type}</p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Amount</h5>
                      <p className="text-muted">
                        {(orderSummary.originalAmount ? orderSummary.originalAmount : orderSummary.cartAmount).toFixed(2)} {currency}
                      </p>
                    </div>

                  </div>

                  <div className="tax-section border-top  ">
                    <div className="d-flex justify-content-between align-items-center">
                      <h5>Total Tax</h5>
                      <p className="text-muted">
                        {orderSummary.taxAmount.toFixed(2)} {currency}
                      </p>
                    </div>
                    {orderSummary.taxes && orderSummary.taxes.length > 0 && (
                      <div className="tax-details mt-3">
                        <h6 >Tax Breakdown:</h6>
                        <ul className="list-unstyled">
                          {orderSummary.taxes.map((tax, index) => (
                            <li key={index} className="d-flex justify-content-between">
                              <span>{tax.name}:</span>
                              <span>{tax.amount.toFixed(2)} {currency}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>


                  <div className="payable-amount border-top pt-3 ">
                    {(orderSummary.originalAmount + orderSummary.taxAmount) > orderSummary.order_total && (
                      <>
                        <div className="d-flex justify-content-between align-items-center">
                          <h6>Total Amount</h6>
                          <p className="text-muted">
                            {(orderSummary.originalAmount+orderSummary.taxAmount).toFixed(2)} {currency}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">

                          <h6>Remaining Credits</h6>
                          <p className="text-muted">
                            {(orderSummary.remainingAmount).toFixed(2)} {currency}
                          </p>
                        </div>
                      </>
                    )}
                    <div className="d-flex justify-content-between align-items-center">

                      <h5 className="text-danger">Total Payable</h5>
                      <h6 className="text-danger font-weight-bold">
                        {orderSummary.order_total.toFixed(2)} {currency}
                      </h6>
                    </div>
                  </div>

                  {orderSummary.note && (
                    <div className="note-section mt-2">
                      <p className="text-muted italic">{orderSummary.note}</p>
                    </div>
                  )}

                  <div className="d-flex justify-content-center">
                    <Button
                      color='#355BA8'
                      onClick={() => handleProceedToPayment(selectedPlan, orderSummary.order_total)}
                      className="btn btn-primary  w-60 mt-2"
                      disabled={!proceedToPaymentEnabled || loading}
                    >
                      {loading ? "Processing..." : "Proceed to Payment"}
                    </Button>
                  </div>
                </Card>
              </div>
            </Col>

          </Row>
        </Card>
        {razorpayVisible && orderDetails && (
          <RenderRazorpay
            cognito_id={cognito_id}
            orderDetails={orderDetails}
            currency={currency}
            plan_name={selectedPlan.type}
            billing_frequency={selectedPlan.period}
            onPaymentSuccess={handlePaymentSuccess}
            onCancel={handelCancel}
            userDetails={newBillingDetails}
          />
        )}
      </Container>
    </div>
  );
};

export default BillingAddress;
